import * as StyledComponents from '../StyledComponents'
import {INPUT_SIZES, Divider, IconAdd, Switch} from 'cdk-radial';
import {useUnifyAdminStore} from '../../AdminStore';
import { useTranslation } from 'react-i18next';

const CreateCampaign = (): JSX.Element => {
    const { t } = useTranslation();
    const setIsCreateCampaignDialogOpen = useUnifyAdminStore((state) => state.setIsCreateCampaignDialogOpen);

    return <>
     <StyledComponents.StyledButtonWithIcon
                onClick={() => setIsCreateCampaignDialogOpen(true)}
                variant='secondary'
                text={t('campaigns.createButton')}
                icon={<IconAdd/>}
            />
    </>
}

export default function CampaginListHeader(props: {gridRef: any}): JSX.Element {
    const { t } = useTranslation();
    /**
     * Data store
     */
    const searchValue = useUnifyAdminStore(state=>state.campaignSearchValue)
    const setCampaignSearchValue = useUnifyAdminStore(state=>state.setCampaignSearchValue)
    const permissions = useUnifyAdminStore(state => state.permissions) 
    const archiveSwitch = useUnifyAdminStore((state) => state.campaignArchiveSwitch);
    const setCampaignArchiveSwitch = useUnifyAdminStore((state) => state.setCampaignArchiveSwitch);
    const setDialogOpen = useUnifyAdminStore((state) => state.setIsCreateCampaignDialogOpen);

    const onExportDownloadButton = () => {
        props?.gridRef?.current?.api?.exportDataAsExcel({
            processRowGroupCallback: (params:any)  => {
                    return params.node.key;
                },
        });
    };

    const handleArchiveSwitchToggle = (event: any) => {
        setCampaignArchiveSwitch(event);
        setDialogOpen(false);
    }

    return <>
    <Divider/>
        <StyledComponents.StyledHeaderContainer>
            <div style={{"display": "flex"}}>
            <StyledComponents.StyledCampaignHeading headingType='subtitle-2' data-testid='campaign-list'>
                {t('campaigns.title')}
            </StyledComponents.StyledCampaignHeading>
            <StyledComponents.StyledSwitch>
                        <Switch
                              dataTestId="switch"
                              id="archive"
                              label={t('campaigns.showArchived')}
                              labelPosition="before"
                              name="archive"
                              onChange={(event: any) => handleArchiveSwitchToggle(event.target.checked)}
                              size="standard"
                              checked={archiveSwitch}
                            />
                        </StyledComponents.StyledSwitch>
                        </div>
            <StyledComponents.StyledCampaignHeading headingType='subtitle-2' padding='0px 15px'>
                    <StyledComponents.StyledIconFileDownload onClick={()=>onExportDownloadButton()} data-testid='export-search-result-icon' />
                </StyledComponents.StyledCampaignHeading>
        </StyledComponents.StyledHeaderContainer>
        
        <StyledComponents.StyledSearchBoxCampaignContainer>
            <StyledComponents.StyledSearchBox
                dataTestId="admin-search-input"
                className="customize-search-input"
                clearButtonLabel="clearButtonLabel"
                id="admin-grid-search-input-expanded"
                isAlwaysExpanded
                name="admin-grid-search-input-expanded"
                onChange={(searchValue: string) => setCampaignSearchValue(searchValue)}
                placeholder={t('campaigns.search')}
                size={INPUT_SIZES.STANDARD}
                value={searchValue}
            />
            {permissions?.hasCampaignSuperAdminPermissions && !archiveSwitch && <CreateCampaign/>}
        </StyledComponents.StyledSearchBoxCampaignContainer>

    </>
}